import { useEffect, useState } from 'react';

/** Kleine melding als Plex traag is: Home wacht er even niet op en probeert het elke 30 s opnieuw. */
export function PlexSlowNotice() {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const on = (e: Event) => setSlow(!!(e as CustomEvent<boolean>).detail);
    window.addEventListener('tumedia:plex-slow', on);
    return () => window.removeEventListener('tumedia:plex-slow', on);
  }, []);
  if (!slow) return null;
  return (
    <div className="plex-slow" role="status">
      Plex reageert traag. Rijen van Plex worden even overgeslagen; tumedia probeert het vanzelf opnieuw.
      <button className="icon-mini" aria-label="Sluiten" onClick={() => setSlow(false)}>✕</button>
    </div>
  );
}
